import { combineEpics } from "redux-observable";
import { loadEpicReducer } from "./LoadExperimentationGroups.ducks.js";
const rootEpic = combineEpics(loadEpicReducer.epic);
export {
  rootEpic
};
//# sourceMappingURL=LoadExperimentationGroups.epics.js.map
